import stringSimilarity from 'string-similarity';
import { PlayerResource } from '~~apis/resource';

export const sortPossiblePlayers = ({ possiblePlayers, seasonName, teamName, playerNumber, minScore = 0.0 }) => {
  const socredPossiblePlayers = [];
  possiblePlayers.forEach((player) => {
    let score = 0.0;
    player.experiences.sort((a, b) => a.season_year - b.season_year);
    player.experiences = player.experiences.slice(0, 2);
    player.experiences.forEach((experience) => {
      let scoreBase = 0.0;
      let socreInOne = 0.0;
      if (seasonName) {
        scoreBase++;
        socreInOne += stringSimilarity.compareTwoStrings(seasonName, experience.season);
      }
      if (teamName) {
        scoreBase++;
        socreInOne += stringSimilarity.compareTwoStrings(teamName, experience.team);
      }
      if (playerNumber) {
        scoreBase++;
        socreInOne += stringSimilarity.compareTwoStrings(playerNumber, experience.number);
      }
      if (scoreBase === 0.0) {
        return;
      }

      score += socreInOne / scoreBase;
    });

    if (score < minScore) {
      return;
    }
    socredPossiblePlayers.push({
      score,
      ...player,
    });
  });

  socredPossiblePlayers.sort((a, b) => a.score - b.score);
  return socredPossiblePlayers;
};

export const getPossibleExistPlayers = ({
  name,
  leagueUniqids = [],
  exact = false,
  seasonName = '',
  teamName = '',
}) => {
  return new Promise((resolve, reject) => {
    const playerName = name.trim();
    PlayerResource.searchSameNamePlayers({ name: playerName, leagueUniqids, exact })
      .then(({ data }) => {
        if (seasonName && teamName) {
          const possiblePlayers = sortPossiblePlayers({ possiblePlayers: data, seasonName, teamName, minScore: 0.8 });
          resolve(possiblePlayers.slice(0, 2));
          return;
        }

        resolve(data);
        return;
      })
      .catch((e) => {
        reject(e);
      });
  });
};
